import type { TableEditResult } from '../schemas'
import ColumnForm from './ColumnForm'
import { useState } from 'react'
import { Popover, PopoverAnchor, PopoverContent } from '@/components/popover/Popover'
import type { TableColumn, TableEdit } from '../schemas'

export default function EditColumnDialog({
  column,
  anchor = null,
  documentBased = false,
  saving,
  onSave,
  onClose,
}: {
  anchor?: HTMLElement | null
  column: TableColumn
  documentBased?: boolean
  saving: boolean
  onSave: (edit: TableEdit) => Promise<TableEditResult>
  onClose: () => void
}) {
  const [dirty, setDirty] = useState(false)
  return (
    <Popover open modal>
      <PopoverAnchor virtualRef={{ current: anchor }} />
      <PopoverContent
        aria-label={`Edit column ${column.name}`}
        align="start"
        width="auto"
        className="w-[440px] max-w-[calc(100vw-32px)] max-h-[min(calc(100dvh-32px),var(--radix-popover-content-available-height))] overflow-y-auto p-4"
        showArrow={false}
        collisionPadding={16}
        onInteractOutside={(event) => event.preventDefault()}
        onPointerDownOutside={() => {
          if (!dirty && !saving) onClose()
        }}
        onEscapeKeyDown={(event) => event.preventDefault()}
        onCloseAutoFocus={(event) => {
          event.preventDefault()
          anchor?.focus()
        }}
      >
        <ColumnForm key={column.id} column={column} documentBased={documentBased} saving={saving} onSave={onSave} onClose={onClose} onDirtyChange={setDirty} />
      </PopoverContent>
    </Popover>
  )
}
